<p-floatLabel>
  <p-select #evaluationTemplateStateDropdown
    id="evaluationTemplateStateDropdown"
    name="evaluationTemplateStateDropdown"
    [options]="evaluationTemplateStates"
    [(ngModel)]="evaluationTemplateState"
    [showClear]="!isRequired"
    [checkmark]="true"
    [disabled]="isReadOnly"
    styleClass="w-100"
    (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="evaluationTemplateStateDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
